module.exports = "https://cdn.realtymogul.com/static/media/Ayla_N.2e738882.jpg";